import { render } from "./delivered.vue?vue&type=template&id=8c39517e"
import script from "./delivered.vue?vue&type=script&lang=js"
export * from "./delivered.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\f0719_o33zc9b\\Documents\\amer\\jeeran-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__